import { Box, Button, Stack, Typography } from '@mui/material';
import { CircleCheck, Copy } from 'lucide-react';
import { useForm } from 'react-hook-form';
import { FormTextField } from 'src/components/Forms/FormTextField/form-text-field';
import { GenericForm } from 'src/components/GenericForm/generic-form';

enum CustomSignupLinkResultField {
  Url = 'url',
}

interface CustomSignupLinkResultValues {
  [CustomSignupLinkResultField.Url]: string;
}

interface CustomSignupLinkResultProps {
  url?: string;
  onCopy?: () => void;
}

const CONFIRMATION_ICON_SIZE = 16;

export const CustomSignupLinkResult = ({ url, onCopy }: CustomSignupLinkResultProps) => {
  const formMethods = useForm<CustomSignupLinkResultValues>({
    defaultValues: { [CustomSignupLinkResultField.Url]: url ?? '' },
  });

  if (!url) {
    return null;
  }

  return (
    <Stack gap={1.5}>
      <Stack direction="row" alignItems="center" gap={1}>
        <Box display="flex" color="success.main">
          <CircleCheck size={CONFIRMATION_ICON_SIZE} />
        </Box>
        <Typography variant="body2">Checkout URL generated successfully.</Typography>
      </Stack>

      <Stack direction="row" alignItems="flex-start" gap={1}>
        <GenericForm<CustomSignupLinkResultValues>
          formMethods={formMethods}
          flex={1}
          minWidth={0}
        >
          <FormTextField
            type="textfield"
            name={CustomSignupLinkResultField.Url}
            label="Checkout URL"
            data-testid="custom-signup-link-url"
            textFieldProps={{
              multiline: true,
              minRows: 3,
              InputProps: { readOnly: true },
            }}
          />
        </GenericForm>
        <Button
          startIcon={<Copy size={CONFIRMATION_ICON_SIZE} />}
          onClick={onCopy}
          data-testid="custom-signup-link-copy"
        >
          Copy
        </Button>
      </Stack>
    </Stack>
  );
};
